import type { labelProviderInterface } from '../components/LabelProviderInterface';
import {cloneObjectWithNoReference} from '../utils/helpers/clone-object-with-no-reference';

export default function (context, facets) {
  const labelProvider: labelProviderInterface = (a, b) => (context as any).labelProvider(a, b); //eslint-disable-line

    const labelFallbacks = {
      'products.facet.categories.categories': 'Categories',
      'products.facet.ranges.ranges': 'Ranges',
      'products.facet.subcategories.subcategories': 'Subcategories',
    };

    const getFieldName = (label) => {
        return labelProvider(label, labelFallbacks[label]);
    };

    return [...cloneObjectWithNoReference(facets)].map(facet => {
        if (facet.displayName === 'subcategory') {
          facet.displayName = getFieldName('products.facet.subcategories.subcategories');
        }
        if (facet.displayName === 'cat') {
          facet.displayName = getFieldName('products.facet.categories.categories');
        }
        if (facet.displayName === 'range') {
          facet.displayName = getFieldName('products.facet.ranges.ranges');
        }
        return facet;
    });
}
